import { Box, Button, Flex, Heading, Image, Text,Link } from "@chakra-ui/react";
import React from "react";

import { FaDownload } from "react-icons/fa";
export default function AboutMe() {
  return (
    <Box
      align="center"
      width={{ base: "95%", md: "80%" }}
      margin={"auto"}
      borderRadius={'45px'}
      paddingTop={20}
      backgroundColor={'csudark'}
      paddingBottom={20}
      id="aboutme"
    >
      <Heading color={"cpnormal"}>About Me</Heading>
      <Flex
        alignItems={"center"}
        justifyContent={"center"}
        flexWrap="wrap-reverse"
        gap={5}
      >
        <Box width={["100%", "70%", "70%", "70%", "70%"]}>
          <br />
          <Text color={"white"} paddingRight={0}>
            Full Stack Web Developer with expertise in MERN stack. Capable of
            writing production-ready code using ReactJS, Redux, and CSS on the
            frontend, NodeJS and Express on the backend to build single-page
            applications. Motivated to advance and expand my skill set through
            targeted mentorship and challenging projects. 6 years of working
            experience in various organized and unorganized sectors, working on
            different projects and taking on different responsibilities.
          </Text>
          <Link style={{ textDecoration: 'none' }}  isExternal href="https://drive.google.com/file/d/1z1u2vlXYc15YC4cj9isdR1qUlZD54LlU/view?usp=share_link">
          <Button _hover={
            {
              backgroundColor:'cpdark'
            }
          }  mt={5} leftIcon={<FaDownload/>}>Download Resume</Button>
          </Link>
        </Box>
        <Box>
          <Image
            src="/images/suhail.jpeg"
            borderRadius="10"
            display={{ base: "block", md: "none" }}
            height={{ base: 200, md: 300 }}
            width={{ base: 200, md: 300 }}
            alt="SUHAIL K"
            objectFit={"cover"}
          ></Image>
        </Box>
      </Flex>
    </Box>
  );
}
